import React, { useEffect, useState } from 'react';

import featureFlags from './featureFlags';
import Context from './context';

/**
 * Provides feature flags to the rest of the page. Handles change events, so
 * other components don't have to. Will always return the most up-to-date flags
 * object as its value.
 */
const FeatureFlagsProvider = ({ children }) => {
  const [flags, setFlags] = useState(featureFlags.getFlags());

  useEffect(() => {
    const listener = (newFlags) => {
      setFlags(featureFlags.getFlags());
    };

    featureFlags.addListener(listener);

    featureFlags.initLocalFlags();

    return () => featureFlags.removeListener(listener);
  }, []);

  return <Context.Provider value={flags}>{children}</Context.Provider>;
};

export default FeatureFlagsProvider;
